export default {
  notification: {
    type: '',
    value: '',
    status: '',
  },
  notificationTimeout: 6000,
  callback: null,
};
